import { useEffect, useState } from 'react'

/**
 * Custom hook to check if the media query matches.
 * @param query - The media query to check
 * @param initialMatches - The initial matches value
 * @returns True if the media query matches, false otherwise
 */
export function useMatchMedia(query: string, initialMatches = false): boolean {
    const [matches, setMatches] = useState(() =>
        typeof window !== 'undefined'
            ? window.matchMedia(query).matches
            : initialMatches
    )

    useEffect(() => {
        const mq = window.matchMedia(query)
        const apply = () => setMatches(mq.matches)
        apply()
        mq.addEventListener('change', apply)
        return () => mq.removeEventListener('change', apply)
    }, [query])

    return matches
}
